import { SizeType } from "antd/es/config-provider/SizeContext";
import { ReactElement } from "react";
import { cn } from "../helper/classNames";
import { Button, Tooltip } from "antd";

interface ICustomButton {
  label?: string;
  disabled?: boolean;
  className?: string;
  shape?: "circle" | "default" | "round" | undefined;
  size?: SizeType;
  icon?: ReactElement | string;
  loading?: boolean;
  onClick?: () => void;
  htmlType?: "submit" | "button" | "reset" | undefined;
  iconPosition?: string;
  name?: string;
  type?: "default" | "primary" | "link" | "text" | "dashed" | undefined;
  isTooltip?: boolean;
  isDanger?: boolean;
  style?: {};
}

const CustomButton = (props: ICustomButton) => {
  const {
    label = "",
    className = "",
    disabled = false,
    shape = "default",
    icon = "",
    size = "middle",
    loading = false,
    onClick = () => null,
    htmlType = "submit",
    iconPosition = "left",
    name = "",
    type = "primary",
    isTooltip = false,
    isDanger = false,
    style = {}
  } = props;
  const iconUi =
    typeof icon === "string" && icon ? (
      <img
        src={icon}
        alt='Icon'
        loading='lazy'
      />
    ) : (
      icon
    );

  const buttonElement = <Button
    className={cn("h-auto bg-primary-blue disabled:bg-paled-blue shadow-md rounded-[0.5rem] uppercase py-1", className)}
    disabled={disabled}
    onClick={onClick}
    shape={shape}
    size={size}
    loading={loading}
    type={type}
    htmlType={htmlType}
    danger={isDanger}
    title={name}
    style={{borderRadius: 15, ...style}}
  >
    {iconPosition === "left" && icon && <span>{iconUi}</span>}
    {label}
    {iconPosition === "right" && icon && <span>{iconUi}</span>}
  </Button>;

  return isTooltip
    ? <Tooltip title={name ? name : label}>{buttonElement}</Tooltip>
    : buttonElement;
};

export default CustomButton;
